import { render, staticRenderFns } from "./contextMenu.vue?vue&type=template&id=19682484&scoped=true"
import script from "./contextMenu.vue?vue&type=script&lang=js"
export * from "./contextMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19682484",
  null
  
)

export default component.exports